export default __webpack_public_path__ + "static/media/Artboard 20 1.15fbdcc6.svg";